export const COSMIC = 'cosmic';
export const TECH = 'tech';
export const MUTANT = 'mutant';
export const SKILL = 'skill';
export const SCIENCE = 'science';
export const MYSTIC = 'mystic';
export const UNIVERSAL = 'universal';



// WEBPACK FOOTER //
// ./src/data/ids/types.js